import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { QueryClientProvider, QueryClient } from '@tanstack/react-query'
import { StrictMode } from 'react'

import { App } from 'app/App'
import { msalConfig } from 'auth/config'
import { ApiProvider } from 'providers/ApiProvider'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
})

const fallbackInstance = new PublicClientApplication(msalConfig)

interface RootProps {
  msalInstance?: PublicClientApplication
  getToken?: () => Promise<string>
}

export const Root = ({ msalInstance, getToken }: RootProps) => {
  const instance = msalInstance ?? fallbackInstance

  return (
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <div id="marketing-capabilities-root" className="tour-experience-profile-get-started experience-profile-body">
          <MsalProvider instance={instance}>
            <ApiProvider getToken={getToken}>
              <App />
            </ApiProvider>
          </MsalProvider>
        </div>
      </QueryClientProvider>
    </StrictMode>
  )
}
